import { Component } from '@angular/core'
import { GeneralService } from 'src/app/services/general/general.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { UserService } from 'src/app/services/user/user.service'
import { BlockedCoupangAd } from './blocked-coupang-ad'
import { ModalService } from 'src/app/services/modal/modal.service'

/** 컨텐츠 가리는 쿠팡 광고 */
@Component({
  selector: 'app-blocked-coupang-ad',
  templateUrl: './blocked-coupang-ad.component.html',
  styleUrls: ['./blocked-coupang-ad.component.scss'],
})
export class BlockedCoupangAdComponent extends BlockedCoupangAd {
  constructor(
    protected generalService: GeneralService,
    protected logService: LogService,
    protected localeService: LocaleService,
    protected userService: UserService,
    protected modalService: ModalService
  ) {
    super(generalService, logService, localeService, userService, modalService)
  }
}
